import React, { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import BlockContent from '../../components/BlockContent';
import BannerWidget from '../../components/BannerWidget';
import { OFFERS_BY_ALIAS_ROUTE, OFFERS_ARCHIVE_ROUTE } from '../../constants/redirect';
import { Link } from 'react-router-dom';
import {
  getCurrentOffer,
  getCurrentBanner,
  getPictureFromLastUnactiveOffer,
} from './requests';
import { formatClientDateRange } from '../../constants/dateTimeFormat';
import './index.css';

const offersWithPicture = (offers) => (
  Array.isArray(offers) ? offers.filter((offer) => offer.picture) : []
);

export default function Offers() {
  const [currentOffer, setCurrentOffer] = useState({});
  const [bannerData, setBannerData] = useState(null);
  const [archivePic, setArchivePic] = useState('');

  const processingRequest = async () => {
    setCurrentOffer(offersWithPicture((await getCurrentOffer()).data));
    setBannerData((await getCurrentBanner()).data);
    setArchivePic((await getPictureFromLastUnactiveOffer()).data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    processingRequest();
  }, []);

  return (
    <div className="page-offers">
      <BlockContent>
        <div className="big-column">
          <MetaTags>
            <title>{currentOffer[0] && currentOffer[0].alias && currentOffer[0].alias.length > 0 ? currentOffer[0].title : 'Акции - Новое Радио'}</title>
            <meta name="description" content={currentOffer[0] && currentOffer[0].description && currentOffer[0].description.length > 0 ? currentOffer[0].description : 'Акции - Новое Радио'} />
          </MetaTags>
          {currentOffer.length > 1 ? currentOffer.map((item, index) => (
            <Link
              key={item.alias ?? item.id ?? `offer-${index}`}
              to={OFFERS_BY_ALIAS_ROUTE + item.alias}
              className={`current-offer__container ${index > 0 && 'margin-top'}`}
            >
              <div className="current-offer__image">
                <img src={item.picture.replace('static', '')} alt={item.title} />
              </div>
            </Link>
          )) : currentOffer[0]?.picture && (
            <div className="current-offer__container">
              <div className="current-offer__dates">
                {formatClientDateRange(currentOffer[0].publish_date, currentOffer[0].unpublish_date)}
              </div>
              <div className="current-offer__title">{currentOffer[0].title}</div>
              <div className="current-offer__image">
                <img src={currentOffer[0].picture.replace('static', '')} alt={currentOffer[0].title} />
              </div>
              <div
                className="content-editor"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: currentOffer[0].content }}
              />
              <div
                className="content-editor"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: currentOffer[0].google_form ? currentOffer[0].google_form : '' }}
              />
            </div>
          )}
        </div>
        <div className="small-column__chart">
          <BannerWidget
            local
            title="Архив акций"
            img={archivePic ? archivePic.picture.replace('static', '') : ''}
            redirect={OFFERS_ARCHIVE_ROUTE}
          />
          {bannerData && bannerData.map((elem, index) => (
            <BannerWidget
              key={elem.id ?? elem.link ?? `banner-${index}`}
              img={elem.picture}
              redirect={elem.link}
            />
          ))}
        </div>
      </BlockContent>
    </div>
  );
}
